export const ROCKETLANE_EMAILS = {
  support: 'care@rocketlane.com',
};
export const ROCKETLANE_LOGIN = 'https://rocketlane.com/login';
export const ROCKETLANE_PRIVACY = 'https://rocketlane.com/legal/privacy-policy';

export const EXTRA_DETAILS =
  '8cfe65b6e9ba1f95284157e667703fb73b1fff322448ea14c6e6a31f97b2dbd2';
